import React from 'react';
import PropTypes from 'prop-types';
import TraderTable from './TraderTable';

export default function MaintainTraders(props) {
  const { companyId, isReadOnly } = props;
  return (
    <div>
      <TraderTable companyId={companyId} isReadOnly={isReadOnly} />
    </div>
  );
}
MaintainTraders.propTypes = {
  companyId: PropTypes.string,
  isReadOnly: PropTypes.bool,
};
